import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=02fb4c54"
import script from "./patientDetail.vue?vue&type=script&lang=js"
export * from "./patientDetail.vue?vue&type=script&lang=js"
import style0 from "./patientDetail.vue?vue&type=style&index=0&id=02fb4c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports